import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "shell info-container info-padding" }
const _hoisted_2 = { class: "info-light-title" }
const _hoisted_3 = { class: "display-flex justify-content-end flex1" }
const _hoisted_4 = { class: "info-item info-item-bottom" }
const _hoisted_5 = { class: "info-label-title" }
const _hoisted_6 = { class: "info-label-content" }
const _hoisted_7 = { class: "info-item info-item-bottom" }
const _hoisted_8 = { class: "info-label-title" }
const _hoisted_9 = { class: "info-label-content" }
const _hoisted_10 = { class: "info-item info-item-bottom" }
const _hoisted_11 = { class: "info-label-title" }
const _hoisted_12 = { class: "info-label-content" }
const _hoisted_13 = { class: "info-item info-item-bottom" }
const _hoisted_14 = { class: "info-label-title" }
const _hoisted_15 = { class: "info-label-content" }
const _hoisted_16 = { class: "info-item" }
const _hoisted_17 = { class: "info-label-title" }
const _hoisted_18 = { class: "info-label-content" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", {
  class: "line",
  style: {"margin-top":"22px"}
}, null, -1)
const _hoisted_20 = { class: "info-title-bottom" }
const _hoisted_21 = { class: "info-light-title" }
const _hoisted_22 = { class: "search-container" }
const _hoisted_23 = { class: "search-form-item" }
const _hoisted_24 = /*#__PURE__*/_createVNode("span", { class: "el-icon-search" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("span", { class: "el-icon-my-add" }, null, -1)
const _hoisted_26 = { class: "search-container" }
const _hoisted_27 = { class: "search-form-item" }
const _hoisted_28 = /*#__PURE__*/_createVNode("span", { class: "el-icon-search" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("span", { class: "el-icon-my-remove" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_property_bread_crumb = _resolveComponent("property-bread-crumb")
  const _component_cus_button = _resolveComponent("cus-button")
  const _component_secondary_nav = _resolveComponent("secondary-nav")
  const _component_cus_option = _resolveComponent("cus-option")
  const _component_cus_select = _resolveComponent("cus-select")
  const _component_el_input = _resolveComponent("el-input")
  const _component_button_tip = _resolveComponent("button-tip")
  const _component_list = _resolveComponent("list")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_property_bread_crumb, { headers: _ctx.breadCrumbHeaders }, null, 8, ["headers"]),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", {
        class: [_ctx.info.UnitID === '0'?'info-title-havbutton-bottom':'info-title-bottom','display-flex']
      }, [
        _createVNode("b", _hoisted_2, _toDisplayString(_ctx.$wordList.DeviceDetailDetailBasic), 1),
        _createVNode("div", _hoisted_3, [
          (_ctx.info.UnitID === '0')
            ? (_openBlock(), _createBlock(_component_cus_button, {
                key: 0,
                type: "blue",
                onClick: _ctx.edit,
                class: "info-title-button"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$wordList.TabelConfigInHtmlModify), 1)
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ])
      ], 2),
      _createVNode("div", _hoisted_4, [
        _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$wordList.ProperAllTextAccessGroupName), 1),
        _createVNode("label", _hoisted_6, _toDisplayString(_ctx.info.Name), 1)
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$wordList.ProperAllTextRepeats), 1),
        _createVNode("label", _hoisted_9, _toDisplayString(_ctx.info.SchedulerTypeLabel), 1)
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode("label", _hoisted_11, _toDisplayString(_ctx.$wordList.TabelTmpKeyInHtmlBeginTime), 1),
        _createVNode("label", _hoisted_12, _toDisplayString(_ctx.info.SchedulerType == 0 ? _ctx.info.StartDay : _ctx.info.StartTime), 1)
      ]),
      _createVNode("div", _hoisted_13, [
        _createVNode("label", _hoisted_14, _toDisplayString(_ctx.$wordList.TabelTmpKeyInHtmlEndTime), 1),
        _createVNode("label", _hoisted_15, _toDisplayString(_ctx.info.SchedulerType == 0 ? _ctx.info.StopDay : _ctx.info.StopTime), 1)
      ]),
      _createVNode("div", _hoisted_16, [
        _createVNode("label", _hoisted_17, _toDisplayString(_ctx.$wordList.TabelUpdateBoxDevice), 1),
        _createVNode("label", _hoisted_18, _toDisplayString(_ctx.info.Location), 1)
      ]),
      _hoisted_19,
      _createVNode("div", _hoisted_20, [
        _createVNode("b", _hoisted_21, _toDisplayString(_ctx.$wordList.ProperAllTextPeople), 1)
      ]),
      _createVNode(_component_secondary_nav, {
        navs: _ctx.secNavs,
        active: _ctx.secActive,
        onChoose: _ctx.chooseSecNav
      }, null, 8, ["navs", "active", "onChoose"]),
      (_ctx.secActive == 'add')
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            _createVNode("div", _hoisted_22, [
              _createVNode("div", _hoisted_23, [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.OutAccessSearchValue,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.OutAccessSearchValue = $event))
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_cus_select, {
                      modelValue: _ctx.OutAccessSearchKey,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.OutAccessSearchKey = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.searchKeyList, (item) => {
                          return (_openBlock(), _createBlock(_component_cus_option, {
                            key: item,
                            value: item.name,
                            label: item.label
                          }, null, 8, ["value", "label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createVNode(_component_cus_button, {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateList++))
              }, {
                default: _withCtx(() => [
                  _hoisted_24,
                  _createTextVNode(" " + _toDisplayString(_ctx.$wordList.LogInHtmlSearch), 1)
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_list, {
              class: "max-height450px overflow-auto",
              headers: _ctx.headers,
              requestData: _ctx.OutAccessRequestData,
              keyOfCheck: "UUID",
              showCheck: "OnlyCheck",
              showDefaultAction: [],
              action: _ctx.addAction,
              update: _ctx.updateList,
              onMultipleSelect: _ctx.multipleSelect
            }, {
              NameSlot: _withCtx((data) => [
                _createTextVNode(_toDisplayString(data.scope.Name) + " ", 1),
                (_ctx.projectType==='community')
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      (data.scope.Type === 'User')
                        ? (_openBlock(), _createBlock(_component_button_tip, {
                            key: 0,
                            color: "#676767"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextResident), 1)
                            ]),
                            _: 1
                          }))
                        : (data.scope.Type === 'Delivery')
                          ? (_openBlock(), _createBlock(_component_button_tip, {
                              key: 1,
                              color: "#676767"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextDelivery), 1)
                              ]),
                              _: 1
                            }))
                          : (data.scope.Type === 'Staff')
                            ? (_openBlock(), _createBlock(_component_button_tip, {
                                key: 2,
                                color: "#676767"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$wordList.OfficeStaff), 1)
                                ]),
                                _: 1
                              }))
                            : (data.scope.Type === 'PmApp')
                              ? (_openBlock(), _createBlock(_component_button_tip, {
                                  key: 3,
                                  color: "#676767"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$wordList.PmApp), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                    ], 64))
                  : (_ctx.projectType==='office')
                    ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                        (data.scope.Role === '31')
                          ? (_openBlock(), _createBlock(_component_button_tip, {
                              key: 0,
                              color: "#676767"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$wordList.AdvancedUser), 1)
                              ]),
                              _: 1
                            }))
                          : (data.scope.Role === '30')
                            ? (_openBlock(), _createBlock(_component_button_tip, {
                                key: 1,
                                color: "#676767"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$wordList.BasicUser), 1)
                                ]),
                                _: 1
                              }))
                            : (data.scope.Type === 'Delivery')
                              ? (_openBlock(), _createBlock(_component_button_tip, {
                                  key: 2,
                                  color: "#676767"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextDelivery), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["headers", "requestData", "action", "update", "onMultipleSelect"]),
            _createVNode(_component_cus_button, {
              type: "iconblue",
              class: "margin-top10px",
              onClick: _ctx.setPerson
            }, {
              default: _withCtx(() => [
                _hoisted_25
              ]),
              _: 1
            }, 8, ["onClick"])
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.secActive == 'remove')
        ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
            _createVNode("div", _hoisted_26, [
              _createVNode("div", _hoisted_27, [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.InAccessSearchValue,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.InAccessSearchValue = $event))
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_cus_select, {
                      modelValue: _ctx.InAccessSearchKey,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.InAccessSearchKey = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.searchKeyList, (item) => {
                          return (_openBlock(), _createBlock(_component_cus_option, {
                            key: item,
                            value: item.name,
                            label: item.label
                          }, null, 8, ["value", "label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createVNode(_component_cus_button, {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateList++))
              }, {
                default: _withCtx(() => [
                  _hoisted_28,
                  _createTextVNode(" " + _toDisplayString(_ctx.$wordList.LogInHtmlSearch), 1)
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_list, {
              class: "max-height450px overflow-auto",
              headers: _ctx.headers,
              requestData: _ctx.InAccessRequestData,
              keyOfCheck: "UUID",
              showCheck: "OnlyCheck",
              showDefaultAction: [],
              action: _ctx.removeAction,
              update: _ctx.updateList,
              onMultipleSelect: _ctx.multipleSelect
            }, {
              NameSlot: _withCtx((data) => [
                _createTextVNode(_toDisplayString(data.scope.Name) + " ", 1),
                (_ctx.projectType === 'community')
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      (data.scope.Type === 'User')
                        ? (_openBlock(), _createBlock(_component_button_tip, {
                            key: 0,
                            color: "#676767"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextResident), 1)
                            ]),
                            _: 1
                          }))
                        : (data.scope.Type === 'Delivery')
                          ? (_openBlock(), _createBlock(_component_button_tip, {
                              key: 1,
                              color: "#676767"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextDelivery), 1)
                              ]),
                              _: 1
                            }))
                          : (data.scope.Type === 'Staff')
                            ? (_openBlock(), _createBlock(_component_button_tip, {
                                key: 2,
                                color: "#676767"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$wordList.OfficeStaff), 1)
                                ]),
                                _: 1
                              }))
                            : (data.scope.Type === 'PmApp')
                              ? (_openBlock(), _createBlock(_component_button_tip, {
                                  key: 3,
                                  color: "#676767"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$wordList.PmApp), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                    ], 64))
                  : (_ctx.projectType==='office')
                    ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                        (data.scope.Role === '31')
                          ? (_openBlock(), _createBlock(_component_button_tip, {
                              key: 0,
                              color: "#676767"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$wordList.AdvancedUser), 1)
                              ]),
                              _: 1
                            }))
                          : (data.scope.Role === '30')
                            ? (_openBlock(), _createBlock(_component_button_tip, {
                                key: 1,
                                color: "#676767"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$wordList.BasicUser), 1)
                                ]),
                                _: 1
                              }))
                            : (data.scope.Type === 'Delivery')
                              ? (_openBlock(), _createBlock(_component_button_tip, {
                                  key: 2,
                                  color: "#676767"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextDelivery), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["headers", "requestData", "action", "update", "onMultipleSelect"]),
            _createVNode(_component_cus_button, {
              type: "iconread",
              class: "margin-top10px",
              onClick: _ctx.setPerson
            }, {
              default: _withCtx(() => [
                _hoisted_29
              ]),
              _: 1
            }, 8, ["onClick"])
          ], 64))
        : _createCommentVNode("", true)
    ])
  ]))
}